/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Field_Vehicle_CountInputs */

const en_clients_field_vehicle_count = /** @type {(inputs: Clients_Field_Vehicle_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Number of vehicles`)
};

const pt_br2_clients_field_vehicle_count = /** @type {(inputs: Clients_Field_Vehicle_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Número de veículos`)
};

/**
* | output |
* | --- |
* | "Number of vehicles" |
*
* @param {Clients_Field_Vehicle_CountInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const clients_field_vehicle_count = /** @type {((inputs?: Clients_Field_Vehicle_CountInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Field_Vehicle_CountInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_field_vehicle_count(inputs)
	return pt_br2_clients_field_vehicle_count(inputs)
});